<div class="audio audio__new">
    <audio #audio></audio>
    <button class="btn" (click)="onStartRecording()">{{ 'player.open-audio.record' | translate }}</button>
    <button class="btn" (click)="onStopRecording()">{{ 'player.open-audio.stop' | translate }}</button>
    <button class="btn" (click)="onDownload()">{{ 'player.open-audio.download' | translate }}</button>
    <button class="btn button btn-action" [promiseBtn]="promiseSetBySomeAction" (click)="onUpload()">{{ 'player.common.button.upload' | translate }}</button>
</div>
